// Access token
export const FETCH_TOKEN_LOADING = "SPOTIFY_FETCH_TOKEN_LOADING";
export const FETCH_TOKEN_SUCCESS = "SPOTIFY_FETCH_TOKEN_SUCCESS";
export const FETCH_TOKEN_FAILURE = "SPOTIFY_FETCH_TOKEN_FAILURE";

// Tracks data
export const FETCH_TRACKS_LOADING = "SPOTIFY_FETCH_TRACKS_LOADING";
export const FETCH_TRACKS_SUCCESS = "SPOTIFY_FETCH_TRACKS_SUCCESS";
export const FETCH_TRACKS_FAILURE = "SPOTIFY_FETCH_TRACKS_FAILURE";
